import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _classCallCheck from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;
var __jsx = React.createElement;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { connect } from 'react-redux';
import withMatch from '@/hocs/withMatch';
import styled from 'styled-components';
import { colorPalette, fonts, shadows, CUBIC_TIMING, rollOutLeft, fadeIn } from '../../../styles/styleGuide';
import { hideApiError } from '../../../redux/globalApiError';
import { fromBreakpoint } from '../../../styles/breakpoints';
import { clearCache as _clearCache } from '../../../redux/apiData';
import CloseCross from '../icons/CloseCross';
import Spinner from './Spinner';
import get from 'lodash.get';
var mapStateToProps = function mapStateToProps(state) {
  return {
    globalApiConfig: state.apiData.globalConfig,
    error: state.globalApiError
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    clearCache: function clearCache() {
      return dispatch(_clearCache());
    },
    hideError: function hideError() {
      return dispatch(hideApiError());
    }
  };
};
var ErrorBar = /*#__PURE__*/function (_Component) {
  function ErrorBar() {
    _classCallCheck(this, ErrorBar);
    return _callSuper(this, ErrorBar, arguments);
  }
  _inherits(ErrorBar, _Component);
  return _createClass(ErrorBar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.init(this.props);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.init(this.props);
    }
  }, {
    key: "init",
    value: function init(_ref) {
      var error = _ref.error,
        hideError = _ref.hideError,
        clearCache = _ref.clearCache,
        match = _ref.match,
        router = _ref.router;
      switch (error.showError && error.body && error.body.status_code) {
        case 401:
        case 403:
          setTimeout(function () {
            hideError();
            router === null || router === void 0 || router.push("/".concat(String(match.params.projectSlug || ''), "/closed"));
            clearCache();
          }, 3000);
          break;
        default:
          break;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        error = _this$props.error,
        hideError = _this$props.hideError,
        globalApiConfig = _this$props.globalApiConfig;
      var errorCode = get(error, 'body.status_code', undefined);
      var message;
      var buttons;
      switch (globalApiConfig && globalApiConfig.errorMessages && error.showError && errorCode) {
        case 401:
        case 403:
          message = get(globalApiConfig, "errorMessages[".concat(errorCode, "]"), globalApiConfig.errorMessages && globalApiConfig.errorMessages["default"]);
          buttons = __jsx(SpinnerContainer, {
            "data-id": "ui_ErrorBar_SpinnerContainer"
          }, __jsx(Spinner, {
            monochrome: true,
            color: "#ffffff",
            size: "small",
            "data-id": "ui_ErrorBar_Spinner"
          }));
          break;
        case 500:
          message = get(globalApiConfig, "errorMessages[500]", globalApiConfig.errorMessages && globalApiConfig.errorMessages["default"]);
          buttons = __jsx(Button, {
            onClick: hideError,
            "data-id": "ui_ErrorBar_Button"
          }, __jsx(CloseCross, {
            "data-id": "ui_ErrorBar_CloseCross"
          }));
          break;
        default:
          break;
      }
      return error.showError ? __jsx(Bar, {
        "data-id": "ui_ErrorBar_Bar"
      }, __jsx(Content, {
        "data-id": "ui_ErrorBar_Content"
      }, message), __jsx(Buttons, {
        "data-id": "ui_ErrorBar_Buttons"
      }, buttons)) : null;
    }
  }]);
}(Component);
export default withMatch(connect(mapStateToProps, mapDispatchToProps)(ErrorBar));
var Bar = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  position: fixed;\n  z-index: 9;\n  bottom: 20rem;\n  left: 20rem;\n  background: ", ";\n  color: #fff;\n  max-width: 320rem;\n  width: 100%;\n  font-family: ", ";\n  ", ";\n  transform-origin: 0 0;\n  animation: ", " 0.6s ", ";\n  animation-fill-mode: forwards;\n\n  ", ";\n"])), colorPalette.blue, fonts.primary, shadows.boxPrimary, rollOutLeft, CUBIC_TIMING, fromBreakpoint.md(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    max-width: 450rem;\n  "]))));
var Content = styled.span(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  width: 100%;\n  padding: 0 15rem;\n  opacity: 0;\n  animation: ", " 0.6s ", ";\n  animation-delay: 0.6s;\n  animation-fill-mode: forwards;\n"])), fadeIn, CUBIC_TIMING);
var Buttons = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n  margin-left: auto;\n"])));
var SpinnerContainer = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: flex;\n  max-height: 40rem;\n  max-width: 40rem;\n  padding: 15rem;\n"])));
var Button = styled.button(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  padding: 15rem;\n"])));